module.exports = __webpack_public_path__ + "static/img/pic_05@2x.370001de.png";